import _ from 'lodash'

export function request (params) {
  let data = [
    {
      name: 'Michael F. Albanese, CPA',
      company: 'Company Nmae',
      legalOrder: 'PCAOB Release No. 105-2016-018 / June 14, 2016',
      location: 'Lakewood, CO',
      date: 'September 25, 2009'
    },
    {
      name: 'Michael F. Albanese, CPA',
      company: 'Company Nmae',
      legalOrder: 'PCAOB Release No. 105-2016-018 / June 14, 2016',
      location: 'Lakewood, CO',
      date: 'September 25, 2009'
    },
    {
      name: 'Michael F. Albanese, CPA',
      company: 'Company Nmae',
      legalOrder: 'PCAOB Release No. 105-2016-018 / June 14, 2016',
      location: 'Lakewood, CO',
      date: 'September 25, 2009'
    }
  ]

  const length = data.length

  // Sort On
  if (params.sortOn) {
    data = _.orderBy(data, params.sortOn, params.sortDir || 'desc')
  }

  // Handle Page
  let page = 1
  if (params.page) page = params.page
  // Page Size
  if (params.pageSize) {
    data = data.slice(page === 1 ? 0 : (page - 1) * params.pageSize, page === 1 ? params.pageSize : ((page - 1) * params.pageSize) + params.pageSize)
  }

  return {
    totalRecords: length,
    pages: Math.ceil(length / params.pageSize),
    pageSize: params.pageSize,
    records: data,
    sortOn: params.sortOn,
    isRealTime: false,
    bySymbol: true
  }
}
